import { useMemo } from "react";
import { SignatureTemplate } from "../../../@types/signatures";
import { SendRenderContext, renderHtmlForSend } from "../../../services/signaturesHtmlSend";
import { SignatureDocumentPreview } from "./SignatureDocumentPreview";

export type IframeTemplatePreviewProps = {
  template: SignatureTemplate;
  ctx: SendRenderContext;
  zoom?: number;
};

// Keeps the existing import name while replacing live HTML with the same PDF
// compilation used when this document is sent.
export default function IframeTemplatePreview({ template, ctx, zoom = 1 }: IframeTemplatePreviewProps) {
  const html = useMemo(
    () => renderHtmlForSend(template.content?.html || "", { ...ctx, mode: "send" }),
    [template, ctx]
  );
  return <SignatureDocumentPreview html={html} zoom={zoom} />;
}
